module.exports = __webpack_public_path__ + "img/trophy-line.d4c5468d.svg";